import Breadcrumbs from '../components/Breadcrumbs'
import Slider from 'react-slick'
import { getCategories } from '../lib/apiService'
import { useEffect, useState } from 'react';
import SearchInput from '../components/SearchInput';
import useProductSearch from '../hooks/useProductSearch';
import NextArrow from '../components/NextArrow';
import PrevArrow from '../components/PrevArrow';
import ProductCard from '../components/ProductCard';
import useIsMobileDevice from '../hooks/useIsMobileDevice';


const Products = () => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [categorySearchTerm, setCategorySearchTerm] = useState('');
  const {
    productSearchTerm,
    productsLoading,
    productsLastElementRef,
    filteredProducts,
    handleProductSearchTermOnKeyUp,
    handleProductSearchIconClick,
    handleOnProductSearchTermChange,
    productsError
  } = useProductSearch(selectedCategories);
  const isMobileDevice = useIsMobileDevice();

  const sliderSettings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          // dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  useEffect(() => {
    const fetchCategories = async () => {
      const categories = await getCategories({ searchTerm: categorySearchTerm });
      setFilteredCategories(categories);
    };
    fetchCategories();
  }, [categorySearchTerm]);

  const handleSelectCategory = (category) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(selectedCategories.filter(cat => cat !== category));
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  const handleCategorySearchTermOnKeyUp = async (e) => {
    if (e.key === 'Enter') {
      setFilteredCategories(await getCategories({ searchTerm: categorySearchTerm }));
      setSelectedCategories([]);
    }
  };
  const handleCategorySearchIconClick = async () => {
    setFilteredCategories(await getCategories({ searchTerm: categorySearchTerm }));
    setSelectedCategories([]);
  };

  

  return (
    <div className='w-full bg-gray-200 pb-10'>
      <div className='w-11/12 mx-auto pt-10'>
        <Breadcrumbs />

        <section>
          <h1 className="text-3xl font-bold text-left py-4">
            All our categories
          </h1>
          <div className=' bg-slate-100 p-10 rounded-md shadow-md'>
          <SearchInput
              placeholder='Search categories'
              value={categorySearchTerm}
              onChange={(e) => setCategorySearchTerm(e.target.value)}
              classNameContainer='w-full flex flex-row items-center bg-white  border border-gray-300 shadow-md rounded-md p-2 mb-4'
              classNameInput='w-full bg-white outline-none'
              onKeyUp={handleCategorySearchTermOnKeyUp}
              inputSize={isMobileDevice ? "w-[95%]" : "w-[98%]"}
              iconSize={isMobileDevice ? "w-[5%]" : "w-[2%]"}
              onIconClick={handleCategorySearchIconClick}
            />
            {filteredCategories.length > 0 ? (
              <Slider {...sliderSettings}>
                {filteredCategories.map((category, index) => (
                  <div
                    key={index}
                    className={
                      `relative p-2 mx-3 w-full h-40 ${selectedCategories.includes(category) && 'bg-blue-300 text-blue-400 shadow-lg'} hover:cursor-pointer hover:shadow-lg hover:bg-blue-500 hover:text-blue-400 rounded-lg flex justify-center items-center`
                    }
                    onClick={() => handleSelectCategory(category)}
                  >
                    <img 
                      src={category.imageUrl}
                      alt={category.name}
                      className='w-full h-full object-cover rounded-md text-center mx-auto text-white'
                    />
                    <div className='absolute inset-0 flex items-center justify-center'>
                      <h1 className={`border border-gray-500 shadow-md text-lg font-bold ${selectedCategories.includes(category) ? 'text-blue-600 bg-white' : 'text-white bg-black' } text-center px-2 py-1 rounded-md`}>
                        {category.name}
                      </h1>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className='flex justify-center items-center h-40'>
                <h1 className='text-2xl font-bold text-gray-500'>No categories found</h1>
              </div>
            )
          }

          </div>
        </section>
        <section>
          <div className='my-10'>
            {selectedCategories.length > 0 ? (
              <>
                <h2 className='text-3xl font-bold text-left py-4'>
                  Filtered Products for the following categories :
                  
                </h2>
                <ul className='list-disc list-inside'>
                  {selectedCategories.map((category, index) => (
                    <li key={index} className='text-2xl text-bold'>{category.name}</li>
                  ))}
                </ul>
                </>
            ) : (
                <h2 className='text-3xl font-bold text-left py-4'>All Products</h2>
            )}
          </div>
          <SearchInput
              placeholder='Search products'
              value={productSearchTerm}
              onChange={handleOnProductSearchTermChange}
              classNameContainer='w-full flex flex-row items-center bg-gray-50  border border-gray-300 rounded-md p-2 mb-4 shadow-md'
              onKeyUp={handleProductSearchTermOnKeyUp}
              classNameInput='w-full bg-gray-50 outline-none'
              inputSize={isMobileDevice ? "w-[95%]" : "w-[98%]"}
              iconSize={isMobileDevice ? "w-[5%]" : "w-[2%]"}
              onIconClick={handleProductSearchIconClick}
            />

            {productsError && (
              <div className='flex justify-center items-center h-40'>
                <h1 className='text-2xl font-bold text-gray-500'>{productsError}</h1>
              </div>
            )}

            {!productsLoading && !filteredProducts.length && (
              <div className='flex justify-center items-center h-40'>
                <h1 className='text-2xl font-bold text-gray-500'>No Products Found</h1>
              </div>
            )}
            {filteredProducts.length > 0 && (
              <div className={`grid ${isMobileDevice ? 'grid-cols-1' : 'grid-cols-3'} gap-2`}>
                {filteredProducts.map((product, index) => (
                  filteredProducts.length === index + 1 ? (
                    <ProductCard
                      key={index}
                      product={product} 
                      lastElementRef={productsLastElementRef}
                    />
                  ) : (
                    <ProductCard
                      key={index}
                      product={product} 
                    />
                  )
                ))}
              </div>
            )}

            {productsLoading && (
              <div className='flex justify-center items-center h-40'>
                <h1 className='text-2xl font-bold text-gray-500'>
                  Loading {' '}
                  <div className="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                </h1>
              </div>
            )}
          

        </section>
      </div>
    </div>
  )
}

export default Products